import { useState } from 'react';

import { useTitle } from 'hooks/useTitle';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Title from 'shared/components/Title';
import KeyOrderCreateForm from '../KeyOrderCreateForm';

const TopBar = () => {
  const title = useTitle();

  const [showedKeyOrderCreateForm, showKeyOrderCreateForm] = useState(false);

  const handleOpenCreateForm = () => {
    showKeyOrderCreateForm(true);
  };

  const handleCloseCreateForm = () => {
    showKeyOrderCreateForm(false);
  };

  return (
    <Stack alignItems="center" direction="row" spacing={3}>
      <Title>{title}</Title>
      <Button
        color="success"
        sx={{ fontWeight: 600 }}
        onClick={handleOpenCreateForm}
      >
        UUSI AVAINTILAUS
      </Button>
      {showedKeyOrderCreateForm && (
        <KeyOrderCreateForm onClose={handleCloseCreateForm} />
      )}
    </Stack>
  );
};

export default TopBar;
